import { render } from "./MiniStatisticsCard.vue?vue&type=template&id=65e73a77&scoped=true"
import script from "./MiniStatisticsCard.vue?vue&type=script&lang=js"
export * from "./MiniStatisticsCard.vue?vue&type=script&lang=js"

import "./MiniStatisticsCard.vue?vue&type=style&index=0&id=65e73a77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e73a77"]])

export default __exports__